package com.wintermar.inspection.feature.domain.model.answer

import com.wintermar.inspection.graphql.type.FindingCategory
import com.wintermar.inspection.graphql.type.InspectionAnswerType

data class AnswerModel(
    val id: String = "",
    val inspectionId: String = "",
    val questionId: String = "",
    val notes: String = "",
    val files: List<AnswerFileModel> = emptyList(),
    val isRequiredFileOrNotes: Boolean = false,
    val answerLocation: AnswerLocationModel = AnswerLocationModel(),
    val answerDateIso: String = "",
    val answerOptionId: String = "", //YES/NO/NA or COMPLIANCE/NON-COMPLIANCE/NA
    val answerSelection: AnswerSelectionModel = AnswerSelectionModel(), //Vessel or User
    val answerText: String = "",
    val lastUpdatedIsoUtc0: String = "",
    val isSubmitted: Boolean = false,
    val findingCategory: FindingCategory? = null
) {

    fun acceptableToDelete(answerType: InspectionAnswerType): Boolean {
        return isEmptyAnswer(answerType, true) || isSubmitted
    }

    fun isFailedSubmit(answerType: InspectionAnswerType): Boolean {
        return !isEmptyAnswer(answerType, true) && !isSubmitted
    }

    fun isEmptyAnswer(answerType: InspectionAnswerType, required: Boolean): Boolean {
        if (!required) return false

        return when (answerType) {
            InspectionAnswerType.FREE_TEXT -> answerText.isEmpty()
            InspectionAnswerType.ADDRESS -> answerLocation.name.isEmpty()
            InspectionAnswerType.CALENDAR -> answerDateIso.isEmpty()
            InspectionAnswerType.VESSEL_ID,
            InspectionAnswerType.USER_ID -> answerSelection.id.isEmpty()

            InspectionAnswerType.COMPLIANCE_NON_COMPLIANCE_NA,
            InspectionAnswerType.YES_NO_NA -> answerOptionId.isEmpty()

            else -> false
        }
    }

    fun isEmptyFileAndNotes(): Boolean {
        if (!isRequiredFileOrNotes) return false
        return files.isEmpty() || notes.trim().isEmpty()
    }

    fun isEmptyFindingCategory(): Boolean {
        return isNullOrUnknownFindingCategory() && isRequiredFileOrNotes
    }

    fun isNullOrUnknownFindingCategory(): Boolean {
        return findingCategory == null || findingCategory == FindingCategory.UNKNOWN__
    }

    fun isEmptyDocumentWithAnswerOption(answerType: InspectionAnswerType): Boolean {
        return (isEmptyFileAndNotes() || isEmptyFindingCategory()) &&
                (answerType == InspectionAnswerType.YES_NO_NA ||
                        answerType == InspectionAnswerType.COMPLIANCE_NON_COMPLIANCE_NA)
    }

    fun isAnswered(answerType: InspectionAnswerType): Boolean {
        return when (answerType) {
            InspectionAnswerType.FREE_TEXT -> answerText.isNotEmpty()
            InspectionAnswerType.ADDRESS -> answerLocation.name.isNotEmpty()
            InspectionAnswerType.CALENDAR -> answerDateIso.isNotEmpty()
            InspectionAnswerType.VESSEL_ID,
            InspectionAnswerType.USER_ID -> answerSelection.id.isNotEmpty()

            InspectionAnswerType.COMPLIANCE_NON_COMPLIANCE_NA,
            InspectionAnswerType.YES_NO_NA -> answerOptionId.isNotEmpty()

            else -> false
        }
    }

    fun getAnswerByType(answerType: InspectionAnswerType): String {
        return when (answerType) {
            InspectionAnswerType.FREE_TEXT -> answerText
            InspectionAnswerType.ADDRESS -> answerLocation.name
            InspectionAnswerType.CALENDAR -> answerDateIso
            InspectionAnswerType.VESSEL_ID,
            InspectionAnswerType.USER_ID -> answerSelection.answerSelectionId

            InspectionAnswerType.COMPLIANCE_NON_COMPLIANCE_NA,
            InspectionAnswerType.YES_NO_NA -> answerOptionId

            else -> ""
        }
    }
}
